/** The hero piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { HeroEvents } from './contract';
import { HeroView } from './HeroView';
import { useHero } from './useHero';

export function Hero(props: PieceInput<HeroEvents>) {
  return <HeroView {...useHero(props)} />;
}
